// Unpublished Work © 2023-2024 Deere & Company.

import { ListItemText, MenuItem, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { GridColumnMenuContainer } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";
import { SelectDropDownMenuProps } from "./types";

const SelectDropdownMenu = ({
  existingProps,
  enableSelectAllPages,
  enableSelectAllNew,
  enableSelectNone,
  selectAllPageTooltip,
  selectAllNewTooltip,
  onSelectAllPages,
  onSelectAllNew,
  onSelectNone,
}: SelectDropDownMenuProps) => {
  const { hideMenu, ...other } = existingProps;
  const theme = useTheme();
  const { t } = useTranslation("invoices");

  return (
    <GridColumnMenuContainer
      hideMenu={hideMenu}
      {...other}
      style={{ minWidth: "122px" }}
    >
      {enableSelectAllPages && (
        <MenuItem
          onClick={(e) => {
            hideMenu(e);
            onSelectAllPages();
          }}
        >
          <ListItemText>{t("allInvoices.dropDown.allPages")}</ListItemText>
        </MenuItem>
      )}
      {!enableSelectAllPages && (
        <Tooltip placement="right" title={selectAllPageTooltip}>
          <div>
            <MenuItem style={{ color: theme.tokens.FuelColorTextDisabled }}>
              <ListItemText>{t("allInvoices.dropDown.allPages")}</ListItemText>
            </MenuItem>
          </div>
        </Tooltip>
      )}
      {enableSelectAllNew && (
        <MenuItem
          onClick={(e) => {
            hideMenu(e);
            onSelectAllNew();
          }}
        >
          <ListItemText>{t("allInvoices.dropDown.allNew")}</ListItemText>
        </MenuItem>
      )}
      {!enableSelectAllNew && (
        <Tooltip placement="right" title={selectAllNewTooltip}>
          <div>
            <MenuItem style={{ color: theme.tokens.FuelColorTextDisabled }}>
              <ListItemText>{t("allInvoices.dropDown.allNew")}</ListItemText>
            </MenuItem>
          </div>
        </Tooltip>
      )}
      <MenuItem
        onClick={(e) => {
          hideMenu(e);
          onSelectNone();
        }}
        style={{
          color: !enableSelectNone
            ? theme.tokens.FuelColorTextDisabled
            : "default",
        }}
      >
        <ListItemText>{t("allInvoices.dropDown.none")}</ListItemText>
      </MenuItem>
    </GridColumnMenuContainer>
  );
};

export default SelectDropdownMenu;
